import './styles.scss';
import image1 from 'images/gallery/gallery-1.jpg';
import image2 from 'images/gallery/gallery-2.jpg';
import image3 from 'images/gallery/gallery-3.jpg';
import image4 from 'images/gallery/gallery-4.jpg';
import image5 from 'images/gallery/gallery-5.jpg';
import image6 from 'images/gallery/gallery-6.jpg';
import image7 from 'images/gallery/gallery-7.jpg';
import image8 from 'images/gallery/gallery-8.jpg';
import MarqueeRow from './MarqueeRow';

const images = [image1, image2, image3, image4];
const images2 = [image5, image6, image7, image8];

const MarqueeGallery = () => (
    <div className="marquee-gallery-section">
        <h2>Our team</h2>
        <div className="marquee-gallery">
            <MarqueeRow list={images} />
            <MarqueeRow list={images2} toRight time={15} />
        </div>
    </div>
);

export default MarqueeGallery;
